import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Star, Zap } from 'lucide-react';
export function BonusSection() {
  return <section className="py-20 bg-gradient-to-br from-blue-900 via-gray-900 to-black text-white overflow-hidden relative" data-id="element-15">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff33_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-16"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <motion.span initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} className="inline-block bg-yellow-500 text-black font-extrabold px-6 py-2 rounded-full text-sm mb-6 shadow-[0_0_20px_rgba(234,179,8,0.5)]" data-id="element-19">
            OFERTA ESPECIAL HOY
          </motion.span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-20">
            Llevate todo el Megapack <br className="hidden md:block" data-id="element-21" />+ Bonos
            Exclusivos
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-22">
            No solo te llevás el sistema de clases, también incluimos
            herramientas extra para potenciar tu enseñanza.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: -2
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-24">
            <div className="relative" data-id="element-25">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-2xl blur-2xl opacity-30 transform rotate-3" data-id="element-26"></div>
              <img src="https://cdn.magicpatterns.com/uploads/dFkjyvnqo8ERC7s1gg3Jtv/kkXXjm1513828.webp" alt="Bonos exclusivos Pack Inglés" className="relative w-full rounded-2xl shadow-2xl border border-white/10" data-id="element-27" />
            </div>
          </motion.div>

          <div className="flex-1 space-y-6 w-full" data-id="element-28">
            <div className="bg-white/5 p-6 md:p-8 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-29">
              <div className="flex items-start gap-5" data-id="element-30">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 p-3 rounded-xl text-black shadow-lg flex-shrink-0" data-id="element-31">
                  <Gift className="w-6 h-6" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-34">
                    BONO #1: Ebooks & Guías PDF
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-35">
                    Material complementario para profundizar en temas
                    específicos y tener siempre recursos a mano.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-6 md:p-8 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300" data-id="element-36">
              <div className="flex items-start gap-5" data-id="element-37">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 p-3 rounded-xl text-black shadow-lg flex-shrink-0" data-id="element-38">
                  <Star className="w-6 h-6" data-id="element-39" />
                </div>
                <div data-id="element-40">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-41">
                    BONO #2: Audio Guides
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-42">
                    Recursos de audio para practicar listening y pronunciación
                    con tus alumnos.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-6 md:p-8 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 relative overflow-hidden" data-id="element-43">
              <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-44">
                HOT
              </div>
              <div className="flex items-start gap-5" data-id="element-45">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-600 p-3 rounded-xl text-black shadow-lg flex-shrink-0" data-id="element-46">
                  <Zap className="w-6 h-6" data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <h3 className="text-xl font-bold text-yellow-400 mb-2" data-id="element-49">
                    BONO #3: Licencia de Reventa (MRR/PLR)
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-50">
                    ¡Increíble! Podés usar este material e incluso revenderlo si
                    quisieras. Tu inversión vuelve multiplicada.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center md:text-left pt-6 pl-2" data-id="element-51">
              <p className="text-xl font-medium text-gray-400 mb-2" data-id="element-52">
                Valor total de los bonos:{' '}
                <span className="text-red-400 line-through decoration-2" data-id="element-53">
                  $45.000
                </span>
              </p>
              <p className="text-4xl font-extrabold text-green-400 tracking-tight" data-id="element-54">
                HOY: GRATIS
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}